// React
import * as React from 'react';

// Redux
import { connect } from 'react-redux';
import * as actions from 'actions';

// Custom Components
import MessageBoxSC from './MessageBoxSC';

// Vendor Utils
import anchorme from "anchorme";
const moment = require('moment-timezone');
import cloneDeep from 'lodash/cloneDeep';

// Vendor Components
import VisibilitySensor from 'react-visibility-sensor';
import CircularProgress from 'material-ui/CircularProgress';

// Custom Utils
import { scrollToBottom } from 'utils/messagingUtils';
import { constants } from 'constants/index';
import { cynoEncryptionKey } from '../../utils/database/database-utils.js';


// React component to render a complete chat feed
class MessagesList extends React.Component {
    props; // this is important only for typescript

    chat = {
        clientHeight: 0,
        scrollHeight: 0,
        scrollTop: 0,
    };

    panel = {};
    
    messages = [];

    constructor(props) {
        super(props);
        this.state = {
            allowedToLoadPrevious: props.allowedToLoadPrevious,
            count: 0,
            firstScrollPosition: 0,
            keepToBottom: null,
            loadingPrevious: false,
            messages: [],
            messagesLoaded: props.messagesLoaded,
            scrolledToBottom: false,
            userScrolled: false,
        }
    }

    handleWheelScroll = (e) => {
        // console.log('YOU SCROLLED, stopping continuous scroll to bottom');
        this.setState({
            userScrolled: true
        }, ()=>{
            // console.log('USER HAS SCROLLED ', this.state.userScrolled);
            clearInterval(this.state.keepToBottom);
            this.panel.removeEventListener('wheel', this.handleWheelScroll, true);
            this.props.resetShouldScrollToBottom();
            this.setState({
                scrolledToBottom: true
            });
        });
    }

    componentDidMount() {
         // Listen for user scroll, if they scroll stop scrolling to bottom
         this.panel.addEventListener('wheel', this.handleWheelScroll, true);
        
        this.setState((prevState) => ({
            keepToBottom: setInterval(()=>{
                if (!prevState.userScrolled) { this.scrollToBottom() };
            }, 5)
        }));
        
        // In case they don't scroll stop interval after 5 seconds
        setTimeout(() => {
            clearInterval(this.state.keepToBottom);
            // console.log('CLEAR INTERVAL after 10 seconds');
            if (this.panel /* PANEL NODE WILL BE UNDEFINED IF THIS COMP IS UNMOUNTED AFTER SETTIMEOUT */) { this.panel.removeEventListener('wheel', this.handleWheelScroll, true) };
        }, 10000)
        
    }

    componentWillReceiveProps(nextProps) {
        const { selectedService: nextSelectedService, notificationCounts: nextNotificationCounts } = nextProps;
        const { selectedService: prevSelectedService, notificationCounts: prevNotificationCounts } = this.props;
        const prevNotificationCountsPerService = prevNotificationCounts && prevNotificationCounts[prevSelectedService._id];
        const nextNotificationCountsPerService = nextNotificationCounts && nextNotificationCounts[nextSelectedService._id];
        // HIDE NEW BADGE NOTIFICATIONS FOR THIS TAB WHILE THE TAB IS MOUNTED
        if (nextNotificationCountsPerService && prevNotificationCountsPerService && prevNotificationCountsPerService.newChatMessageCount !== nextNotificationCountsPerService.newChatMessageCount) {
            this.handleClearNotifications();
        }
    }

    componentDidUpdate(prevState, prevProps) {
        if ((this.props.messagesLoaded && prevProps.messagesLoaded === false)) {
            // console.log('SCROLLING TO BOTTOM @ CDU');
            this.scrollToBottom();
            this.setState({
                scrolledToBottom: true
            });
            // console.log('MESSAGES LOADED @ LIST', this.props.messagesLoaded, prevProps.messagesLoaded, prevProps);
            this.convertLinks();
        }
        if (prevProps.shouldScrollToBottom !== this.props.shouldScrollToBottom && this.props.shouldScrollToBottom) {
            // Scrolls to bottom that are triggered by parent ChatComponent
            this.scrollToBottom();
            this.props.resetShouldScrollToBottom();
            this.convertLinks();
        }
    }

    convertLinks = () => {
        // rce-mbox-text
        const messageNodesObject = document.querySelectorAll('.rce-mbox-text');
        // console.log('ARRAY OF MESSAGE NODES', messageNodesObject);
        
        messageNodesObject.forEach(messageNode => {
            // console.log('MESSAGE TEXT', messageNode, messageNode.innerText);
            
            messageNode.innerHTML = anchorme(messageNode.innerText, {
                files: false,
                ips: false
            })
        })
        // document.getElementById("b").innerText = anchorme(string,{
        //     urls:false,
        // });
    }

    scrollToBottom = () => {
        scrollToBottom(this.chat);
    }
    
    loadPreviousMessages = (isVisible) => {
        // console.log('I AM VISIBLE', this.props.messagesRedux.length, this.props.allowedToLoadPrevious)
        if (this.props.messagesRedux.length > 19 /*&& this.props.allowedToLoadPrevious*/) {
            // console.log('IS VISIBLE?', isVisible, this.state.loadingPrevious);
            if (!isVisible || /*!this.props.allowedToLoadPrevious ||*/ this.state.loadingPrevious) {return null;}
            
            // console.log('COUNT CALC (count/count*19/length/nodeindex)', this.state.count, this.state.count * 19, this.props.messages.length - 1, this.props.messages.length - 1 - (this.state.count * 19));
            // const allmess = document.querySelectorAll(".messages .message");
            // console.log('MESSAGES', allmess );

            this.setState((prevState) => {
                return {
                    count: prevState.count + 1,
                    loadingPrevious: true,
                }
            });

            return this.props.loadMoreMessages()
            .then((previousMessages) => {
                // console.log('PREV MESS', previousMessages, previousMessages.length, document.querySelectorAll('.messages .message'));
                if (previousMessages && (previousMessages.length > 0)) {
                    let lastLoadedMessage = document.querySelectorAll('.messages .message')[previousMessages.length];
                    if (lastLoadedMessage && lastLoadedMessage.parentNode && lastLoadedMessage.parentNode.scrollTop) {
                        process.nextTick(() => {
                            lastLoadedMessage.parentNode.scrollTop = lastLoadedMessage.offsetTop - lastLoadedMessage.parentNode.offsetTop;

                            this.convertLinks();
                            return this.setState({
                                loadingPrevious: false
                            });
                        });
                    }
                }
            })
            .catch(console.log);
        }
    }
    
    handleClearNotifications = () => {
        this.props.clearNotifications({
            clientId: this.props.selectedClient && this.props.selectedClient.uid,
            serviceId: this.props.selectedService && this.props.selectedService._id,
            type: 'newMessage', 
            userId: this.props.userData && this.props.userData.uid,
        })
        .then(() => {
            refreshNotificationUI()
        })
        .catch(console.log);
        
        const refreshNotificationUI = () => {
            // console.log('REFRESHING NOTIFICATIONS @ MessagesLIST');
            
            // console.log('user/provider/service', this.props.userData && this.props.userData.uid, this.props.selectedService && this.props.selectedService.provider, this.props.selectedService && this.props.selectedService._id);
            this.props.refreshNotifications();
            
            if (this.props.userData.provider) {
                // IF THE USER IS THE PROVIDER THE SENDER IS THE CLIENT
                // console.log('REFRESHING PROVIDER NOTIFICATION UI');
                
                this.props.getNotificationCounts({
                    senderId: this.props.selectedClient && this.props.selectedClient.uid,
                    serviceId: this.props.selectedService && this.props.selectedService._id,
                    userId: this.props.userData && this.props.userData.uid,
                });
            } else {
                // console.log('REFRESHING CLIENT NOTIFICATION UI');
                // IF THE USER IS THE CLIENT THE SENDER IS THE PROVIDER
                this.props.getNotificationCounts({
                    senderId: this.props.selectedService && this.props.selectedService.provider,
                    serviceId: this.props.selectedService && this.props.selectedService._id,
                    userId: this.props.userData && this.props.userData.uid,
                });
            }
        }
    }

    renderMessages = (messages) => {
        const { messagesRedux } = this.props;

        const messageNodes = messagesRedux.map((message, index) => {
            return (
                <div 
                    key={ index } 
                    ref={ (node) => {this.messages.push(node)}} 
                    className="message"
                    // style={{ backgroundColor: 'red', marginBottom: 30, }}
                >
                    <MessageBoxSC
                        position={(message.senderId === this.props.userData.uid) ? 'right' : 'left'}
                        type={(message.photoURL) ? 'photo' : 'text'}
                        text={message.text}
                        // style={{backgroundColor: 'red', col}}
                        data={{ 
                            alt: 'cyno chat image',
                            height: '100%',
                            status: {
                                click: true,
                                loading: 0
                            },
                            uri: message.photoURL,
                            width: 200,
                        }}
                        date={moment(message.createdAt, 'x').local()} // pass
                        className={(message.senderId === this.props.userData.uid) ? 'sender' : 'receiver'} // this can be used to style the send and receiver differently in the custom css file
                        notch={ true/* ONLY SHOW NOTCH IF THE LAST ID IS NOT YOURS OR THERE IS NOT MESSAGE BEFORE (MESSAGES IS index 0*/}
                        onClick={() => {
                            // alert('You clicked on a message')
                            }}
                        css={`
                            .rce-mbox {
                                box-shadow: -4px 8px 20px 0px rgba(0,0,0,0.03);
                                margin-left: 30px;
                            }
                            .rce-mbox.rce-mbox-right {
                                margin-right: 30px;
                            }
                        `}
                    />
                </div>
            );
        });
        return messageNodes;
    }

    render() {
        const { maxHeight, messagesRedux } = this.props;
        
        return (
            <div ref={ panel => this.panel = panel } id="chat-panel" style={styles.chatPanel}>
                <div
                    ref={node => {
                        this.chat = node;
                    }}
                    className="messages"
                    style={{ ...styles.chatHistory, display: 'flex', flexFlow: 'column nowrap' }}
                >
                    { messagesRedux && messagesRedux.length > 19 && this.props.loadMoreMessages &&
                        <div style={{ marginBottom: 20, display: 'flex', justifyContent: 'center' }}>
                            <VisibilitySensor
                                delay={ 0 } 
                                containment={ this.chat }
                                delayedCall={true}
                                partialVisibility={true}
                                active={!this.state.loadingPrevious}
                                // onChange={ this.loadPreviousMessages }
                            >
                                {({isVisible}) => {
                                    if (isVisible) {
                                        this.loadPreviousMessages(isVisible);
                                    }
                                    return <CircularProgress size={ 40 } thickness={ 5 } />
                                }}
                            </VisibilitySensor>
                        </div>
                    }
                    { messagesRedux.length > 0 &&
                        this.renderMessages(this.props.messagesRedux)
                    }
                    { this.props.isPhotoUploading &&
                        <div 
                            className="uploadingSpinner" 
                            style={{ 
                                overflow: 'hidden', 
                                display: 'flex', 
                                flexDirection: 'column', 
                                margin: '10px 30px', 
                                justifyContent: 'center', 
                                padding: '10px 40px', 
                                minHeight: 430, 
                                height: 430, 
                                alignItems: 'center', 
                                backgroundColor: 'rgba(50,50,50,0.1)', 
                                borderRadius: '10px' 
                            }}
                        >
                            <div>
                                <CircularProgress size={ 300 } thickness={ 230 } />
                            </div>
                            <div style={{ height: 0, position: 'relative', top: -220, textAlign: 'center' }}>
                                <p style={{ fontFamily: 'Open Sans', fontSize: 30, marginBottom: -10 }}>Uploading...</p>
                                <span style={{ fontSize: 12, color: 'rgba(0,0,0,0.5)' }}>(large photos may take a while)</span>
                                <br />
                            </div>
                        </div>
                    }
                    {
                        <VisibilitySensor
                            delay={ 0 } 
                            containment={ document.querySelector('.messages') }
                            // delayedCall={true}
                            partialVisibility={true}
                            // active={!this.state.loadingPrevious}
                            onChange={ this.handleClearNotifications }
                        />
                        // PUT SENSOR HERE AT THE BOTTOM SO THAT WHEN SCROLLED TO HERE IT WILL RESET THE NOTIFICATIIONS
                    }
                    {
                        messagesRedux.length === 0 && // TODO: style me!
                        <p style={ styles.noMessagesNoticeStyles }>
                            There are no messages yet with this {(this.props.userData.provider) ? 'client' : 'service' }. 
                        </p>
                    }
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ chat, provider, client, notification, service }) => {
    // console.log('NOTIFICATIONS @ CWRP', notification);
    
    return {
        isPhotoUploading: chat.isPhotoUploading,
        messagesRedux: chat.messages,
        // selectedService: service.selectedService,
        // NOTIFICATION PROPS
        notificationCounts: notification.unreadCount,
        userData: client.clientData,
    };
};

export default connect(mapStateToProps, actions)(MessagesList);

const styles = {
    chatHistory: { 
        overflow: 'auto' 
    },
    chatPanel: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        overflow: 'hidden',
    },
    img: {
        borderRadius: 100,
        bottom: 0,
        left: 0,
        position: 'absolute',
        width: 36,
        zIndex: 100,
    },
    noMessagesNoticeStyles: {
        paddingTop: '50%',
        fontSize: constants.text.baseFontStyles.fontSize,
        textAlign: 'center'
    }
};


// WEBPACK FOOTER //
// ./src/js/components/Chat/MessageList.jsx